import { useEffect, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { fetchGetFeatureFlags } from "../queries/featureFlags";
import useNetworkHeaders from "./useNetworkHeaders";

export function useFeatureFlag(featureName: string) {
  const headers = useNetworkHeaders();
  const featureFlagQuery = useQuery(["featureFlags", featureName], fetchGetFeatureFlags(headers));
  const isEnabled = useMemo(() => featureFlagQuery.data?.enabled, [featureFlagQuery.data]);
  return { isEnabled };
}

/**
 *
 * @param featureName Feature flag
 * @param checkKeybind Resolves to true when a keyboard event should override
 */
export function useFeatureFlagWithOverride(featureName: string, checkKeybind: (e: KeyboardEvent) => boolean) {
  const [override, setOverride] = useState(false);
  const headers = useNetworkHeaders();
  const featureFlagQuery = useQuery(["featureFlags", featureName], fetchGetFeatureFlags(headers));
  const isEnabled = useMemo(() => featureFlagQuery.data?.enabled || override, [featureFlagQuery.data, override]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (checkKeybind(event)) {
        console.log(`Overriding ${featureName} to ON`);
        event.preventDefault();
        setOverride(true);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  return { isEnabled };
}
